import seta from "../../assets/seta1.png" 
import sun from "../../assets/sun.png"
import imageBackground from "../../assets/js1.jpg"
 
 
 const dark ={
    backgroundColor: "black",
    textColor: "white",
    siteColor: "rgb(41, 89, 125)",
    hover: "rgb(29, 62, 88)",
    backgroundColorNavFooter:"rgb(11, 11, 11)",
    backgroundImage: imageBackground,
    textMenuColor: "rgb(75, 74, 74)",
    linksColor: "white",
    subscribeCoursesColor:"rgb(176, 169, 169)",
    arrowFooter: seta,
    iconTheme: sun




}



export default dark